import { RouteObject } from 'react-router-dom'
import New from './components/New'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import Detail from './components/Detail'
import List from './components/List'
import POC from './components/POC'
import ScanCards from './components/ScanCards'

const CustomerModule: RouteObject = {
    path: 'customers',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'scan-cards',
            element: <ScanCards />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/poc',
            element: <POC />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default CustomerModule
